import React from 'react';
import {
  FaTh,
  FaChartLine,
  FaHeadset,
  FaBullhorn,
  FaFileAlt,
  FaHome,
} from 'react-icons/fa';

const PRESET_STYLES = {
  default: { bg: '#5c6bc0', Icon: FaTh },
  sales: { bg: '#0d6efd', Icon: FaChartLine },
  service: { bg: '#6f42c1', Icon: FaHeadset },
  marketing: { bg: '#fd7e14', Icon: FaBullhorn },
  content: { bg: '#8d6e63', Icon: FaFileAlt },
  realestate: { bg: '#2e7d32', Icon: FaHome },
};

/**
 * Renders an app icon from config.icon: preset (e.g. preset:sales) or image URL.
 * 32px colorful preset icons for Bento-style launcher.
 * @param {string} icon - '' | 'preset:default' | 'preset:sales' | ... | image URL
 * @param {number} size - Pixel size of the square icon (default 32)
 */
const AppIconDisplay = ({ icon, size = 32 }) => {
  if (!icon || typeof icon !== 'string') {
    return (
      <div
        style={{
          width: size,
          height: size,
          borderRadius: 8,
          backgroundColor: '#e9ecef',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#6c757d',
          fontSize: size * 0.5
        }}
        title="No icon"
      >
        •
      </div>
    );
  }

  if (icon.startsWith('preset:')) {
    const key = icon.replace(/^preset:/, '').toLowerCase();
    const style = PRESET_STYLES[key] || PRESET_STYLES.default;
    const IconComponent = style.Icon;
    return (
      <div
        style={{
          width: size,
          height: size,
          borderRadius: 10,
          backgroundColor: style.bg,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
        }}
        title={key}
      >
        <IconComponent size={size * 0.55} />
      </div>
    );
  }

  return (
    <img
      src={icon}
      alt=""
      style={{
        width: size,
        height: size,
        borderRadius: 10,
        objectFit: 'cover'
      }}
      onError={(e) => {
        e.target.onerror = null;
        e.target.style.display = 'none';
      }}
    />
  );
};

export default AppIconDisplay;
